import React from 'react';

import CalculatorBase from './calculator-base';
import CalculatorInput from './calculator-input';
import CalculatorInputToggle from './calculator-input-toggle';
import CalculatorOutput from './calculator-output';

import { calculateValueAtMaturity } from '../../utilities/calculations';

const renderBasicInputs = (state, processInput) => {
    const { initialInvestment, monthlyAddition, interestRate, yearsUntilMaturity, compoundingFrequency } = state;

    return (
        <div>
            <CalculatorInput id="initialInvestment" label="Initial Investment" defaultValue={initialInvestment} processInput={processInput} />
            <CalculatorInput id="monthlyAddition" label="Monthly Addition" defaultValue={monthlyAddition} processInput={processInput} />
            <CalculatorInput id="interestRate" label="Interest Rate" defaultValue={interestRate} processInput={processInput} format="percent" />
            <CalculatorInput id="yearsUntilMaturity" label="Years Until Maturity" defaultValue={yearsUntilMaturity} processInput={processInput} format="int" />
            <CalculatorInputToggle
                id="compoundingFrequency"
                label="Compounding Frequency"
                offValue="monthly"
                offLabel="Monthly"
                onValue="yearly"
                onLabel="Yearly"
                defaultValue={compoundingFrequency}
                processInput={processInput}
            />
        </div>
    );
};

const renderBasicOutputs = state => (
    <CalculatorOutput label="Value at Maturity" value={calculateValueAtMaturity(state)} headingLevel={1} />
);

export default props => (
    <CalculatorBase
        inputs={renderBasicInputs}
        outputs={renderBasicOutputs}
        {...props}
    />
);
